import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonSegment,
  IonSegmentButton,
} from '@ionic/angular/standalone';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '../shared/shared.module';
import { AdlSummaryComponent } from './access-point/adl-summary/adl-summary.component';
import { AvailabilityCardComponent } from './access-point/adl-summary/availability-card/availability-card.component';
import { ContactCardComponent } from './access-point/adl-summary/contact-card/contact-card.component';
import { IndicatorsCardComponent } from './access-point/adl-summary/indicators-card/indicators-card.component';
import { AdminSearchComponent } from './admin-search/admin-search.component';
import { AdminRoutingModule } from './admin.routing.module';
import { AddDeviceComponent } from './device-admin/add-device/add-device.component';
import { DeleteDeviceComponent } from './device-admin/delete-device/delete-device.component';
import { DeviceAdminComponent } from './device-admin/device-admin.component';
import { LocationAdminComponent } from './location-admin/location-admin.component';
import { AddressFormComponent } from './location-admin/location-profile-popup/address-form/address-form.component';
import { ConfigurationComponent } from './location-admin/location-profile-popup/configuration/configuration.component';
import { FooterActionBarComponent } from './location-admin/location-profile-popup/footer-action-bar/footer-action-bar.component';
import { GroupComponent } from './location-admin/location-profile-popup/group/group.component';
import { LocationFormComponent } from './location-admin/location-profile-popup/location-form/location-form.component';
import { LocationProfilePopupComponent } from './location-admin/location-profile-popup/location-profile-popup.component';
import { AddGroupComponent } from './location-group/add-group/add-group.component';
import { LinkedSitesComponent } from './location-group/linked-sites/linked-sites.component';
import { LocationGroupComponent } from './location-group/location-group.component';
import { AddRouteIdoComponent } from './route-admin/route-admin-ido/add-route-ido/add-route-ido.component';
import { RouteAdminIdoComponent } from './route-admin/route-admin-ido/route-admin-ido.component';
import { RouteAdminNonIdoComponent } from './route-admin/route-admin-non-ido/route-admin-non-ido.component';
import { RouteAdminComponent } from './route-admin/route-admin.component';
import { UserAdminComponent } from './user-admin/user-admin.component';

@NgModule({
  declarations: [
    DeleteDeviceComponent,
    AdminSearchComponent,
    UserAdminComponent,
    DeviceAdminComponent,
    LocationAdminComponent,
    LocationGroupComponent,
    RouteAdminNonIdoComponent,
    RouteAdminIdoComponent,
    RouteAdminComponent,
    LocationProfilePopupComponent,
    LocationFormComponent,
    AddressFormComponent,
    GroupComponent,
    ConfigurationComponent,
    LinkedSitesComponent,
    AddRouteIdoComponent,
    AdlSummaryComponent,
    AddGroupComponent,
    FooterActionBarComponent,
    AvailabilityCardComponent,
    ContactCardComponent,
    IndicatorsCardComponent,
    AddDeviceComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    MatTableModule,
    MatCheckboxModule,
    AdminRoutingModule,
    MatIconModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    NgSelectModule,
    IonRow,
    IonCol,
    IonCardContent,
    IonCard,
    IonGrid,
    IonCardHeader,
    IonCheckbox,
    IonButton,
    IonSegment,
    IonLabel,
    IonSegmentButton,
    IonRadioGroup,
    IonItem,
    IonRadio,
    IonInput,
    ScrollingModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdminModule {}
